import { connectDatabaseEmulator, getDatabase, ref } from 'firebase/database'

import { app } from './app'

const db = getDatabase(app)

if (location.hostname === 'localhost') {
  connectDatabaseEmulator(db, '127.0.0.1', 9000)
}

const DBRefs = {
  games: 'games/',
  players: 'players/',
  stats: 'stats/',
  watchlist: 'watchlist/',
  contact: 'contact/',
}

const gamesRef = (child: string) => ref(db, DBRefs.games + child)
const gameEventsRef = (child: string) => ref(db, DBRefs.games + '/events' + child)
const playersRef = (child: string) => ref(db, DBRefs.players + child)
const statsRef = (child: string) => ref(db, DBRefs.stats + child)
const contactUsRef = (child: string) => ref(db, DBRefs.contact + child)
const watchlistRef = ref(db, DBRefs.watchlist)
const presenceRef = ref(db, '.info/connected')

export { statsRef, gamesRef, playersRef, gameEventsRef, watchlistRef, contactUsRef, presenceRef }
